import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import FlatButton from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Snackbar from '@material-ui/core/Snackbar';
import Info from '@material-ui/icons/Info';

import { Button, IconButton, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import SaveIcon from '@material-ui/icons/SaveAlt';

import globalStyles from '../styles';
import { HIDE_ERRORS } from '../redux/actions/types/messageTypes';
import store from '../store';

const mapStateToProps = state => ({
  message: {
    open: state.messageReducer.show,
    content: state.messageReducer.message,
  },
  errors: state.messageReducer.errors,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const styles = theme => ({
  bigTooltip: {
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
});

class PageBase extends React.Component {

  static propTypes = {
    title: PropTypes.string,
    navigation: PropTypes.string,
    classes: PropTypes.object,
    showCreateButton: PropTypes.bool,
    showEditButton: PropTypes.bool,
    showDeleteButton: PropTypes.bool,
    handleCreateClick: PropTypes.func,
    handleEditClick: PropTypes.func,
    handleDeleteClick: PropTypes.func,
    showBackButton: PropTypes.bool,
    showSaveButton: PropTypes.bool,
    disableSaveButton: PropTypes.bool,
    handleSaveClick: PropTypes.func,
    handleCloseClick: PropTypes.func,
  };

  static defaultProps = {
    handleCreateClick: () => console.log('create!'),
    handleEditClick: () => console.log('edit!'),
    handleDeleteClick: () => console.log('delete!'),
    handleSaveClick: () => console.log('delete!'),
    handleCloseClick: () => console.log('delete!'),
    title: '',
    showCreateButton: false,
    showEditButton: false,
    showDeleteButton: false,
    showBackButton: false,
    showSaveButton: false,
    disableSaveButton: false,
  };

  render() {

    const {
      title,
      navigation,
      classes,
      showCreateButton,
      handleCreateClick,
      showEditButton,
      handleEditClick,
      showDeleteButton,
      handleDeleteClick,
      showBackButton,
      showSaveButton,
      handleSaveClick,
      handleCloseClick,
      disableSaveButton } = this.props;

    return (
      <div>

        <h3 style={globalStyles.title}>
          {(showSaveButton || showBackButton) &&

          <Tooltip title={I18n.t('button.back')} placement="left" classes={{ tooltip: classes.bigTooltip }}>
            <IconButton aria-label="Back" onClick={handleCloseClick}>
              <ArrowLeftIcon />
            </IconButton>
          </Tooltip>
          }

          {title}</h3>
        <Paper
          id="paper"
          style={globalStyles.paper}
          ref={el => this.paper = el}
        >


          {this.props.children}

          <div style={globalStyles.clear} />


          {showCreateButton &&
            <Tooltip title={I18n.t('button.create')} classes={{ tooltip: classes.bigTooltip }}>
              <Button variant="fab" color="primary" aria-label="Add" style={globalStyles.bottomButton} onClick={handleCreateClick}>
                <AddIcon />
              </Button>
            </Tooltip>
          }

          {showEditButton &&
            <Tooltip title={I18n.t('button.edit')} placement="left" classes={{ tooltip: classes.bigTooltip }}>
              <Button variant="fab" color="primary" aria-label="Edit" style={globalStyles.bottomButton} onClick={handleEditClick}>
                <EditIcon />
              </Button>
            </Tooltip>
          }

          {showDeleteButton &&

            <Tooltip title={I18n.t('button.delete')} placement="top" classes={{ tooltip: classes.bigTooltip }}>
              <Button variant="fab" color="secondary" aria-label="Edit" style={globalStyles.secondBottomButton} onClick={handleDeleteClick}>
                <DeleteIcon />
              </Button>
            </Tooltip>
          }

          {showSaveButton &&

            <Tooltip title={I18n.t('button.save')} placement="top" classes={{ tooltip: classes.bigTooltip }}>
              <Button variant="fab" color="primary" aria-label="Save" style={globalStyles.bottomButton} onClick={handleSaveClick} disabled={disableSaveButton}>
                <SaveIcon />
              </Button>
            </Tooltip>
          }


        </Paper>

        <Snackbar
          open={this.props.message.open}
          message={this.props.message.content}
        />

        {/* <Dialog
          style={{ zIndex: 99999 }}
          title={I18n.t('titles.found_errors')}
          open={Boolean(this.props.errors && this.props.errors.length)}
          actions={(
            <FlatButton
              label={I18n.t('application.close')}
              primary
              onTouchTap={() => store.dispatch({ type: HIDE_ERRORS })}
            />
          )}
        >

          <List>
            {
              this.props.errors && this.props.errors.map((error, index) => (
                <ListItem
                  key={index}
                  primaryText={error.value}
                  leftIcon={<Info />}
                />
              ))
            }
          </List>

        </Dialog> */}

      </div>

    );

  }

}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PageBase));



// WEBPACK FOOTER //
// ./src/app/PageBase.js